<template>
    <ValidationObserver :ref="stepName" v-slot="observer">

        <div class="lead-form-iban">
            <div class="lead-form-iban__title">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 69"><g fill="none" fill-rule="evenodd"><g transform="translate(18.347)"><path fill="#02B274" stroke="#02B274" stroke-dasharray="2.16" stroke-linecap="square" stroke-width="1.44" d="M25.061 10.095v33.169"/><rect width="30.773" height="46.873" x="1.44" y="1.44" stroke="#02B274" stroke-width="2.88" rx="6.48"/><rect width="12.172" height="11.613" x="5.728" y="33.131" fill="#02B274" rx="3.6"/></g><path fill="#FA5528" d="m2.474 49.89.986-1.027a3.6 3.6 0 0 1 5.108-.09l11.835 11.51a3.6 3.6 0 0 1 .089 5.073l-.986 1.027a3.6 3.6 0 0 1-5.108.09L2.563 54.963a3.6 3.6 0 0 1-.089-5.073Zm4.887-7 .554-14.23a2.16 2.16 0 0 1 1.17-1.836l14.753-7.586a3.764 3.764 0 0 1 5.25 2.033 4.493 4.493 0 0 1-2.24 5.606l-9.125 4.455a1.44 1.44 0 0 0-.808 1.294v11.81a6.78 6.78 0 0 0 1.969 4.777 6.713 6.713 0 0 0 4.763 1.982h12.6l-8.954 9.018a3.6 3.6 0 0 1-5.056.053L9.334 47.802a6.48 6.48 0 0 1-1.973-4.913Z"/></g></svg>
                <h3>Paiement sécurisé <br class="mobile_hide">avec <br class="desktop_hide"> votre carte Bancaire</h3>
            </div>
            <div v-for="(field,name) in fields" :key="name" class="field-container">
                <button class="btn-displayIbanModal" :class="{'btn-displayIbanModal--active' : displayIbanModal}" @click="displayIbanModal = !displayIbanModal"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><g fill="none" fill-rule="evenodd" stroke="#FA5528"><circle cx="8.5" cy="8.5" r="7.495" stroke-width="2.009"/><path fill="#FA5528" fill-rule="nonzero" stroke-width=".3" d="M7.632 9.833c0-.281.038-.525.114-.733.076-.207.194-.39.354-.55.16-.16.372-.3.635-.422.261-.124.45-.26.567-.405a.815.815 0 0 0 .175-.526c0-.265-.085-.469-.255-.612-.17-.142-.411-.214-.722-.214-.315 0-.562.08-.74.24-.178.16-.276.393-.292.7H6c.024-.716.26-1.28.707-1.693C7.155 5.206 7.755 5 8.508 5c.491 0 .926.09 1.303.272.378.181.67.437.878.767.207.33.311.711.311 1.143 0 .405-.102.763-.305 1.074-.204.31-.509.575-.914.794a2.11 2.11 0 0 0-.402.269.843.843 0 0 0-.22.296.913.913 0 0 0-.07.364v.201H7.632v-.347Zm.734 3.042a.913.913 0 0 1-.684-.275.97.97 0 0 1-.268-.706.97.97 0 0 1 .268-.705.913.913 0 0 1 .684-.276c.277 0 .505.092.683.276a.97.97 0 0 1 .268.705.97.97 0 0 1-.268.706.913.913 0 0 1-.683.275Z"/></g></svg></button>
                <component :is="field._component" :key="name" :name="name" :field="field" :step="step"></component>
            </div>
            <b-button type="button next-button is-primary" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>
        </div>



    </ValidationObserver>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import {Checkbox} from "../../../../../../models/fields/Checkbox";
import {MaskPattern} from "../../../../../../models/fields/Features/mask/MaskPattern";
import {sync} from "vuex-pathify";

export default {
    mixins: [mixin,form_step_mixin],
    data() {
        return {
            displayIbanModal : false,
            fields: {
                iban: new Text()
                    .label('Numéro de carte (IBAN) ')
                    .required()
                    .validation({regex: /^(BE)[0-9]{14}$/})
                    .mask(new MaskPattern('{BE}** **** **** ****').showPlaceholder('X')),
            }
        }
    },
    watch:{
        'iban':{
            handler: function (val, oldVal){
                this.iban = _.toUpper(val)
            },
            immediate: true,
        },
    },
    computed: {
        codice_fiscale: sync('form_data/codice_fiscale'),
        iban: sync('form_data/iban'),
    }
}
</script>
